/* START ****************************************** CART FUNCTIONS */

const cartCheckoutButton = document.getElementById("cart-checkout");
const cartCheckoutButtonSP = document.getElementById("cart-checkout-sp");
const cartCheckoutLoginButton = document.getElementById("cart-checkout-login");
const cartCheckoutLoginButtonSP = document.getElementById(
  "cart-checkout-login-sp"
);
const cartItemChangeContainer = document.getElementById(
  "cart-item-change-container"
);
const cartBuyButtonNotice = document.getElementById("cart-buy-button-notice");

/* CREATE LIST ELEMENT */
function addToList(content) {
  let elem = document.createElement("li");
  if (content) elem.textContent = content;
  cartItemChangeContainer.appendChild(elem);
}

// DISABLES CHECKOUT BUTTON
function disableCheckOutButton() {
  // PC
  cartCheckoutButton.setAttribute("disabled", "");
  cartCheckoutButton.style.opacity = 0.5;
  cartCheckoutButton.value = "DISABLED";

  if (cartCheckoutLoginButton) {
    cartCheckoutLoginButton.style.pointerEvents = "none";
    cartCheckoutLoginButton.style.opacity = 0.5;
  }

  // SP
  cartCheckoutButtonSP.setAttribute("disabled", "");
  cartCheckoutButtonSP.style.opacity = 0.5;
  cartCheckoutButtonSP.value = "DISABLED";

  if (cartCheckoutLoginButtonSP) {
    cartCheckoutLoginButtonSP.style.pointerEvents = "none";
    cartCheckoutLoginButtonSP.style.opacity = 0.5;
  }
}

// ENABLES CHECKOUT BUTTON
function enableCheckOutButton() {
  // PC
  cartCheckoutButton.removeAttribute("disabled");
  cartCheckoutButton.style.opacity = 1;
  cartCheckoutButton.value = "購入手続きへ進む";

  if (cartCheckoutLoginButton) {
    cartCheckoutLoginButton.style.pointerEvents = "auto";
    cartCheckoutLoginButton.style.opacity = 1;
  }

  // SP
  cartCheckoutButtonSP.removeAttribute("disabled");
  cartCheckoutButtonSP.style.opacity = 1;
  cartCheckoutButtonSP.value = "購入手続きへ進む";

  if (cartCheckoutLoginButtonSP) {
    cartCheckoutLoginButtonSP.style.pointerEvents = "auto";
    cartCheckoutLoginButtonSP.style.opacity = 1;
  }
}

/* END ****************************************** CART FUNCTIONS */

/* START ****************************************** CHECK CART INVENTORY */

let productForDeletion = [];
let productForChange = [];

// CONDITIONS
let repairCounterInCart = false;
let repairBallPuncturedInCart = false;

let repairProductInCart = false;
let repairPaymentInCart = false;

let ballPaymentInCart = false;
let counterPaymentInCart = false;

let normalProductInCart = false;
let invalidQuantityInCart = false;
let customProductInCart = false;

let wrappingProductInCart;

let customProductTextEmpty = 0;

let soloProductOnly = false;

// BPLUS CAMPAIGN CONDITIONS
let bPlusProductInCart = false;
let otherNonBPlusProductsInCart = false;
let isSyncingBPlus = false;

let productHandlesInCart = [];
let crowdfundingProduct = false;

// CROWDFUNDING CART NOTE STATE
let cartNoteSavedValue = ''; // 最後に保存した値

let preorderProduct;
let notPreorderProduct = [];

let preorderInCart = [];

let eventProductInCart = [];

let isRoomBasketBall = false;
let isRoomBasketBallSet = false;

//  CHECK PRODUCTS INVENTORY
function checkProductInventory(item1) {
  if (
    item1.product_type !== "cpb_product" &&
    !item1.product_type == "修理商品" &&
    item1.product_type !== "ラッピング" &&
    !product.tags.includes("カートで無視")
  ) {
    let itemQuantity = item1.quantity;

    cartItems.forEach((item2) => {
      if (item1.variant_id == item2.variant_id && item1.key !== item2.key)
        itemQuantity += item2.quantity;
    });

    alert(itemQuantity);

    if (item1.inventory_quantity < itemQuantity) {
      disableCheckOutButton();
      invalidQuantityInCart = true;

      document.querySelector(
        "[data-key='" + item1.key + "']"
      ).style.opacity = 0.5;
    }
  }
}

// CART PRODUCTS CONDITIONS
function checkProducts(product) {
  if (
    product.event == "" &&
    product.product_type !== "ラッピング" &&
    product.product_type !== "cpb_product" &&
    !product.tags.includes("カートで無視")
  ) {
    notPreorderProduct.push(product);
  }
  if (product.event !== "") {
    preorderProduct = product.title;

    if (!preorderInCart.includes(product.title))
      preorderInCart.push(product.title);
  }

  if (product.event !== "") {
    if (!eventProductInCart.includes(product.event))
      eventProductInCart.push(product.event);
  }

  if (product.tags.includes("単体購入商品")) soloProductOnly = product.title;

  productHandlesInCart.push(product.handle);
  if (
    product.tags.includes("crowdfunding") ||
    product.tags.includes("クラウドファンディング")
  )
    crowdfundingProduct = product.title;

  if (product.tags.includes("ボールパンク検査"))
    repairBallPuncturedInCart = true;

  if (product.tags.includes("カウンター修理見積")) repairCounterInCart = true;

  if (product.product_type == "ラッピング")
    wrappingProductInCart = product.properties[0][1];

  if (product.handle == "SYUURI-B" || product.handle == "repair-timer")
    repairPaymentInCart = true;

  if (product.tags.includes("ボールパンク修理")) ballPaymentInCart = true;

  if (product.tags.includes("カウンター修理")) counterPaymentInCart = true;

  if (product.product_type !== "修理商品") normalProductInCart = true;

  if (product.product_type == "修理商品") repairProductInCart = true;

  if (product.product_type == "cpb_product") {
    let ccc = false;

    product.properties.forEach((property) => {
      if (
        property[0] == "文字エリアA" ||
        property[0] == "文字エリアB" ||
        property[0] == "文字エリアC" ||
        property[0].includes("行目")
      )
        ccc = true;
    });
    if (ccc == false) customProductTextEmpty++;
  }

  if (product.sku == "RB-BMSET2" || product.sku == "RB-BMSET3") {
    isRoomBasketBall = true;
  }
  if (product.handle == "rb-bgset") {
    isRoomBasketBall = true;
    isRoomBasketBallSet = true;
  }

  // BPLUS CAMPAIGN PRODUCTS CHECK
  if (product.handle === "wt0010-bp" || product.handle === "tyousei-bpe") {
    bPlusProductInCart = true;
  } else if (!product.tags.includes("カートで無視")) {
    otherNonBPlusProductsInCart = true;
  }
}

// MAIN LOOP COMPARES PRODUCTS

if (typeof cartItems !== "undefined")
  cartItems.forEach((item1) => {
    checkProducts(item1);

    if (item1.inventory_policy == "deny") checkProductInventory(item1);
  });

// CUSTOM PRODUCT HAS EMPTY TEXT
if (customProductTextEmpty > 0) {
  addToList(customProductEmptyErrorMsg);
  disableCheckOutButton();
}

// CHECK PREORDER PRODUCT WITH EVENTS
if (eventProductInCart.length > 1) {
  disableCheckOutButton();
  addToList(
    `「${eventProductInCart.join(
      "と"
    )}」 はイベント先行予約商品との同時購入不可 。単体でご注文ください`
  );
}

// PREORDER  PRODUCTS
if (preorderProduct && cartItems.length >= 2) {
  if (notPreorderProduct.length > 0) {
    disableCheckOutButton();
    addToList(
      `「${preorderProduct}」は予約商品です、他の商品と一緒にご購入いただけません。単体でご注文ください。`
    );
  }
}

// SOLO PRODUCTS
if (soloProductOnly && cartItems.length >= 2) {
  disableCheckOutButton();
  addToList(
    `「${soloProductOnly}」商品は、他の商品と一緒にご購入いただけません。単体でご注文ください。`
  );
}

// CROWDFUNDING ENGRAVING NOTICE (bbouenpj26chd)
if (productHandlesInCart.includes("bbouenpj26chd")) {
  addToList("応援プランB・Cをご注文される方は、下のボックス内に名前刻印情報を入力してください。");
  addToList("全角にて最大17文字以内、英数字の場合は半角にて最大16文字以内でご入力をお願いします。★や♡などの記号/絵文字はお受けできません。");
}

// CROWDFUNDING PRODUCTS
const productHandlesNotDuplicated = [...new Set(productHandlesInCart)];
if (crowdfundingProduct && productHandlesNotDuplicated.length >= 2) {
  disableCheckOutButton();
  addToList(
    `「${crowdfundingProduct}」商品は、他の商品と一緒にご購入いただけません。単体でご注文ください。`
  );
}

// REPAIR PRODUCT + NORMAL IN CART
if (repairProductInCart && normalProductInCart) {
  disableCheckOutButton();
  addToList(repairNormalInCartErrorMsg);
}

// REPAIR PRODUCT + REPAIR PRODUCT
else if (repairCounterInCart && repairBallPuncturedInCart) {
  disableCheckOutButton();
  addToList(repairPaymentErrorMsg);
}

// REPAIR PRODUCT + REPAIR PRODUCT
else if (
  (repairPaymentInCart && repairCounterInCart) ||
  (repairPaymentInCart && repairBallPuncturedInCart)
) {
  disableCheckOutButton();
  addToList(repairProductErrorMsg);
} else if (ballPaymentInCart && counterPaymentInCart) {
  disableCheckOutButton();
  addToList(repairPaymentErrorMsg);
}

let noInventory = [];
noInventory = CART_ITEMS.filter((item) => !item.available);

if (noInventory.length) {
  disableCheckOutButton();
  noInventory.forEach((element) => {
    addToList(
      `「${element.title}」には在庫がありません。商品を削除してください`
    );
  });
}

// ROOM BASKETBALL
if (isRoomBasketBall) {
  if (isRoomBasketBallSet) {
    addToList(
      `※商品は3個口にて発送します。（ボールとマットそれぞれ別の箱でのお届けとなります）`
    );
  } else {
    addToList(
      `※商品は2個口にて発送します。（ボールとマットそれぞれ別の箱でのお届けとなります）`
    );
  }
  addToList(
    `※商品発送後の配送状況につきましては、配送会社の担当営業所様まで直接お伺いをいただけますようお願い致します。`
  );
}

// BPLUS PRODUCTS EXCLUSIVE
if (bPlusProductInCart) {
  if (otherNonBPlusProductsInCart) {
    disableCheckOutButton();
    addToList(
      "「B+シューティングマシン」は他の商品と一緒にご購入いただけません。単体でご注文ください。"
    );
  } else {
    addToList(
      `※設置調整費は自動反映します。`
    );
    addToList(
      `※設置調整作業は、納品時に弊社担当による動作確認や商品説明を行う作業になります。`
    );
    addToList(
      `※納品日は、ご注文後に弊社担当と調整いただき決定します。`
    );
    addToList(
      `※本商品に各種クーポンはご使用いただけません。`
    );
    addToList(
      `※本商品に送料無料特典は適用されません。`
    );
  }
}


/* END ****************************************** CHECK CART INVENTORY */

// START *************************************************** MERGE SPLIT CART ITEMS

function mergeSplitCartItems(items) {
  const result = [];
  const baseMap = {};
  const splitItems = [];
  const toNumber = value =>
    Number(String(value).replace(/[^\d-]/g, ''));
  const toYen = value =>
    `¥${value.toLocaleString()}`;
  items.forEach(item => { 
    const isZeroOnlyDiscount =
      item.line_discounts.length > 0 &&
      item.line_discounts.every(d => d.amount === 0);

    if (isZeroOnlyDiscount) {
      splitItems.push(item);
    } else {
      const mapKey = item.id + ':' + JSON.stringify(item.properties);
      baseMap[mapKey] = result.length;
      result.push({ ...item });
    }
  });
  
  splitItems.forEach(splitItem => {
    const mapKey = splitItem.id + ':' + JSON.stringify(splitItem.properties);
    if (baseMap[mapKey] !== undefined) {
      const base = result[baseMap[mapKey]];
      base.quantity += splitItem.quantity;
      base.original_line_price = toYen(
        toNumber(base.original_line_price) +
        toNumber(splitItem.original_line_price)
      );

      base.final_line_price = toYen(
        toNumber(base.final_line_price) +
        toNumber(splitItem.final_line_price)
      );
      base.delete += '&updates[' + splitItem.key + ']=0';
      base.up = null;
      base.down = null;
    } else {
      result.push({ ...splitItem });
    }
  });
  return result;
}

const DISPLAY_CART_ITEMS = mergeSplitCartItems(CART_ITEMS);

// END *************************************************** MERGE SPLIT CART ITEMS

// START *************************************************** CART WRAPPING
const { createApp, reactive, toRefs, watch, onBeforeMount, onMounted } = Vue;
createApp({
  delimiters: ["${", "}"],
  setup() {
    DISPLAY_CART_ITEMS.forEach(item => {

  if (!item.custom || !item.custom.length) return;

  item.custom.forEach(custom => {
    custom.properties.sort((a, b) => {
      const order = {
        "文字エリアA行数": 1,
        "文字エリアA「1行目」": 2,
        "文字エリアA「2行目」": 3,
        "文字エリアA「3行目」": 4,
        "文字エリアB行数": 10,
        "文字エリアB": 11,
        "文字エリアC行数": 20,
        "文字エリアC": 21,
        "カラー": 30,
        "フォント": 31
      };
      return (order[a[0]] || 999) - (order[b[0]] || 999);
    });
  });
});
    const state = reactive({
      cartItems: DISPLAY_CART_ITEMS,

      //GIFT_ ITEMS
      giftItems: GIFT_ITEMS,
      giftModal: false,
      giftMax: 1,
      giftQuantity: 1,
      giftTarget: null,
      giftType: "",

      lists: [],
      disabled: null,
      loading: true,

      //DISCOUNTS
      discounts: [],
    });

    function gift(item, custom) {
      state.giftType = item.gift_type;
      state.giftQuantity = custom.quantity;
      state.giftMax = custom.quantity;
      state.giftTarget = custom.configId;
      state.giftModal = !state.giftModal;
    }

    function gift1(item) {
      state.giftType = item.gift_type;
      state.giftQuantity = item.quantity;
      state.giftMax = item.quantity;
      state.giftTarget = item.sku;

      if (item.wrapping.length) {
        state.giftQuantity = item.quantity - item.wrapping[0].quantity;
        state.giftMax = item.quantity - item.wrapping[0].quantity;
      }

      state.giftModal = !state.giftModal;
    }

    function properties(property) {
      if (
        property.includes("行目") ||
        property.includes("エリア") ||
        property.includes("カラー") ||
        property.includes("フォント")
      )
        return true;

      return false;
    }

    onMounted(() => {
      state.loading = false;

      // CUSTOM PRODUCT IN CART
      let customProductAvailable = CART_ITEMS.find(
        (item) => item.custom.length
      );
      if (customProductAvailable)
        state.lists.push(
          "名入れ商品の場合は、ご入金確認後7営業日以内の発送となります。"
        );

      // WRAPPING IN AVAILABLE IN CART
      let wrappingAvailable = CART_ITEMS.find((item) => item.wrap);
      if (wrappingAvailable)
        state.lists.push(
          "ギフトラッピングをご希望の方は、ボール毎に設定ください。"
        );

      //INVENTORY
      let noInventory = CART_ITEMS.find(
        (item) =>
          item.inventory_quantity < item.quantity &&
          item.inventory_policy !== "continue" &&
          !"kensa-b syuuri-b smitsumori repair-timer".includes(item.handle)
      );

      // SET DISCOUNTS
      if (CART_ITEMS.length)
        CART_ITEMS.forEach((item) => {
          if (!item.line_discounts.length) return;

          item.line_discounts.forEach((d) => {
            if (!state.discounts.includes(d.title))
              state.discounts.push(d.title);
          });
        });

      //console.log(CART_ITEMS)

      if (noInventory) {
        state.lists.push(
          "申し訳ありませんが、一部の商品が減少または在庫切れになっています。数量を更新するか、削除してください。ご不便をおかけして申し訳ありません。"
        );
        //state.disabled = "在庫切れ"
        disableCheckOutButton();
      }
    });

    return {
      ...toRefs(state),
      gift,
      gift1,
      properties,
    };
  },
}).mount(".shopping_cart");

// END *************************************************** CART WRAPPING

// START ************************************************* CART DELETE IRREGULARITIES

function updateCpbProperties(array) {
  if (array.length)
    array.forEach((item, index) => {
      setTimeout(() => {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        })
          .then((response) => {
            if (response.ok) console.log("REMOVE OTHER PROPERTIES");
          })

          .catch((error) => {
            console.error("Error:", error);
          });
      }, index * 2000);
    });
}

updateCpbProperties(CLEAN_CPB);

// END *************************************************** CART DELETE IRREGULARITIES
// START 26.4.20 LEE　カートチェック処理後の金額表示問題
function formatYenFromCents(cents) {
  return `¥${Number(cents).toLocaleString('ja-JP')}`;
}

async function refreshTotalPriceOnly() {
  const res = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error('Failed to fetch cart');
  }

  const cart = await res.json();
  const totalPriceEls = document.querySelectorAll('.total-price')

  if (totalPriceEls) {
    if(cart.total_price === 0){
      location.reload()
      return
    }

    totalPriceEls.forEach((el) => {
      el.textContent = formatYenFromCents(cart.total_price / 100)
    })
    
  }
}
// END 26.4.20 LEE　カートチェック処理後の金額表示問題
// START ************************************************* CART DELETE CPB THAT HAS NO BALL

function deleteSingleCPB(item) {
  if (item)
    fetch(`/cart/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: item }),
    })
      .then((response) => {
        console.log(response);
        if (response.ok) console.log("REMOVE SINGLE CPB");
        refreshTotalPriceOnly();
      })

      .catch((error) => {
        console.error("Error:", error);
      });
}
if (Object.keys(CPB_NO_BALL).length) deleteSingleCPB(CPB_NO_BALL);


// START ************************************************* CART DELETE BALL THAT HAS NO CPB

function deleteBallNoCpb(item) {
  if (item)
    fetch(`/cart/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: item }),
    })
      .then((response) => {
        if (response.ok) console.log("REMOVE BALL WITHOUT CPB");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
}
if (Object.keys(BALL_NO_CPB).length) deleteBallNoCpb(BALL_NO_CPB);

// END *************************************************** CART DELETE BALL THAT HAS NO CPB

// START ************************************************* CART SYNC CPB QUANTITY TO BALL

function syncCpbQuantity(item) {
  if (item)
    fetch(`/cart/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: item }),
    })
      .then((response) => {
        if (response.ok) console.log("SYNC CPB QUANTITY TO BALL");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
}
if (Object.keys(CPB_QUANTITY_MISMATCH).length) syncCpbQuantity(CPB_QUANTITY_MISMATCH);

// END *************************************************** CART SYNC CPB QUANTITY TO BALL

// START ************************************************* CART PROMO
/*
const cartPromo = document.querySelector('.cart__product')
if(cartPromo)
cartPromo.addEventListener('click', ()=>{

  cartPromo.classList.add('cart__product--loading')
  
  fetch("/cart/add", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items:[
      {
        //ORINIGAL
        id:41515786600642,
        //id:41708176703639,
        quantity:parseInt(cartPromo.dataset.quantity),
        properties: {
          _barcode: 4905741875183
        }
      }
    ] })
  })
  .then(response => {
    if(response.ok)
      return window.location.href="/cart"
  })
})

*/
// END *************************************************** CART PROMO

// START ************************************************* CART NOTE MODAL
// document.addEventListener("DOMContentLoaded", function () {

const cartModalTrigger = document.querySelectorAll("[data-modal]");
const cartBodyModal = document.querySelector("body");
let modal;
if (cartModalTrigger)
  cartModalTrigger.forEach((element) => {
    element.addEventListener("click", function () {
      if (element.dataset.modal !== "")
        //cartBodyModal.classList.toggle('noScroll')
        cartBodyModal.scrolling = "no";

      let modal = document.getElementById(`${element.dataset.modal}`);

      if (element.dataset.modal == "close")
        modal = element.closest(".modal-container");

      if (modal.classList.contains("modal-container__active")) {
        modal.classList.toggle("modal-container__active");

        setTimeout(() => {
          modal.classList.toggle("modal-container__zindex");
        }, 450);
      } else {
        modal.classList.toggle("modal-container__active");
        modal.classList.toggle("modal-container__zindex");
      }
    });
  });

const scrollable = document.querySelectorAll(".scrollable");
if (scrollable)
  scrollable.forEach((element) => {
    // when the scrollable table is scrolled
    element.addEventListener("scroll", function () {
      element.classList.remove("scrollable--inactive");
    });
  });

// });

// END *************************************************** CART NOTE MODAL

// START ************************************************* CART CUSTOM CAMPAIGN

// 対象商品とプレゼント商品を同数にする
async function syncPeladaCampaign() {
  try {
    // 対象商品のハンドル一覧
    const peladaProductHandles = [
      "f5k5000",
      "f5k5001",
      "f5k4000",
      "f5k3000",
      "f4k5000",
      "f4k4000",
      "f4k3000",
      "f9k4000",
      "f9k3000",
      "f3k9200",
      "f5k9100",
      "f5k9200",
      "f5k9300",
    ];

    // プレゼント商品のハンドル
    const peladaPresentHandle = "kkb";

    // カート内の対象商品の合計数量を計算
    const PELADA_PRODUCT = cartItems.filter((item) =>
      peladaProductHandles.includes(item.handle)
    );
    const PELADA_PRODUCT_COUNT = PELADA_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    // カート内のプレゼント商品の合計数量を計算
    const PELADA_PRESENT_PRODUCT = cartItems.filter(
      (item) => item.handle === peladaPresentHandle
    );
    const PELADA_PRESENT_PRODUCT_COUNT = PELADA_PRESENT_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    // 本番のステッカー（プレゼント商品のvariantID）
    const presentVariantId = 51434421682494;

    // BPのステッカー（プレゼント商品のvariantID）
    // const presentVariantId = 45293991493783;

    // 対象商品とプレゼント商品の数量を同数にする
    const is_diff_present_count =
      PELADA_PRODUCT_COUNT !== PELADA_PRESENT_PRODUCT_COUNT;
    if (is_diff_present_count) {
      // 対象商品の行番号を取得（line番号は1から始まるため、indexに+1）
      const targetLineIndex = cartItems.findIndex(
        (item) => item.id === presentVariantId
      );
      if (targetLineIndex === -1) {
        console.error("対象のギフト商品がカート内に見つかりません");
        return;
      }

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            line: targetLineIndex + 1,
            quantity: PELADA_PRODUCT_COUNT,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("カートの更新が完了しました", data);
        window.location.reload();
      } catch (updateError) {
        console.error("カート更新エラー:", updateError);
      }
    }
  } catch (error) {
    console.error("syncPeladaCampaign実行中のエラー:", error);
  }
}

syncPeladaCampaign();
// END *************************************************** CART CUSTOM CAMPAIGN

// START *************************************************** CART FLOAT BUTTON
const cartFloatButton = () => {
  const cartActionWrapper = document.querySelector(".js-cart-action-wrapper");
  if (!cartActionWrapper) return;
  const cartActionContents = cartActionWrapper.querySelector(
    ".js-target-cart-action"
  );
  const modalWrapper = cartActionWrapper.querySelector(".js-modal-wrapper");
  const modalClose = modalWrapper.querySelector(".js-modal-close");
  const modalTargetBody = modalWrapper.querySelector(".js-target-modal-body");
  const cartFloatButton = cartActionWrapper.querySelector(".js-modal-open");
  if (!cartFloatButton) return;

  // Move Cart Action Contents
  const moveToModal = (isMoveToModal) => {
    switch (isMoveToModal) {
      case true:
        modalTargetBody.appendChild(cartActionContents);
        break;
      case false:
        cartActionWrapper.append(cartActionContents);
        break;
      default:
        console.warn("Invalid value for isMoveToModal. Expected boolean.");
        break;
    }
  };

  // Modal Open
  cartFloatButton.addEventListener("click", () => {
    modalWrapper.classList.add("is-show");
    moveToModal(true);
  });

  // Modal Close background click
  modalWrapper.addEventListener("click", (e) => {
    if (e.target === modalWrapper) {
      modalWrapper.classList.remove("is-show");
      moveToModal(false);
    }
  });
  // Modal Close button click
  modalClose.addEventListener("click", () => {
    modalWrapper.classList.remove("is-show");
    moveToModal(false);
  });

  // Float Button show/hide
  window.addEventListener("scroll", () => {
    const cartFloatButton = document.querySelector(".js-modal-open");
    if (!cartFloatButton) return;
    const targetHiddenPoint = document.querySelector(".js-cart-action-wrapper");
    const targetHiddenPointTop = targetHiddenPoint.getBoundingClientRect().top;
    const windowScrollY = window.scrollY;
    switch (true) {
      case windowScrollY > targetHiddenPointTop:
        cartFloatButton.classList.add("is-hidden");
        break;
      case windowScrollY < targetHiddenPointTop:
        cartFloatButton.classList.remove("is-hidden");
        break;
      default:
        console.warn(
          "Invalid value for windowScrollY or targetHiddenPointTop."
        );
        break;
    }
  });
};
cartFloatButton();
// END *************************************************** CART FLOAT BUTTON

// START *************************************************** CART CUSTOM CAMPAIGN
// 対象商品とプレゼント商品を同数にする
async function syncPeladaCampaign() {
  try {
    // 対象商品のハンドル一覧
    const peladaProductHandles = [
      "f5k5000",
      "f5k5001",
      "f5k4000",
      "f5k3000",
      "f4k5000",
      "f4k4000",
      "f4k3000",
      "f9k4000",
      "f9k3000",
      "f3k9200",
      "f5k9100",
      "f5k9200",
      "f5k9300",
    ];

    // プレゼント商品のハンドル
    const peladaPresentHandle = "kkb";

    // カート内の対象商品の合計数量を計算
    const PELADA_PRODUCT = cartItems.filter((item) =>
      peladaProductHandles.includes(item.handle)
    );
    const PELADA_PRODUCT_COUNT = PELADA_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    // カート内のプレゼント商品の合計数量を計算
    const PELADA_PRESENT_PRODUCT = cartItems.filter(
      (item) => item.handle === peladaPresentHandle
    );
    const PELADA_PRESENT_PRODUCT_COUNT = PELADA_PRESENT_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    // 本番のステッカー（プレゼント商品のvariantID）
    const presentVariantId = 51434421682494;

    // BPのステッカー（プレゼント商品のvariantID）
    // const presentVariantId = 45293991493783;

    // 対象商品とプレゼント商品の数量を同数にする
    const is_diff_present_count =
      PELADA_PRODUCT_COUNT !== PELADA_PRESENT_PRODUCT_COUNT;

    console.log(
      "対象商品数量:",
      PELADA_PRODUCT_COUNT,
      "プレゼント商品数量:",
      PELADA_PRESENT_PRODUCT_COUNT,
      "プレゼント商品の数量調整を行うか:",
      is_diff_present_count
    );
    if (is_diff_present_count) {
      // 対象商品の行番号を取得（line番号は1から始まるため、indexに+1）
      const targetLineIndex = cartItems.findIndex(
        (item) => item.id === presentVariantId
      );
      if (targetLineIndex === -1) {
        console.error("対象のギフト商品がカート内に見つかりません");
        return;
      }

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            line: targetLineIndex + 1,
            quantity: PELADA_PRODUCT_COUNT,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("カートの更新が完了しました", data);
        window.location.reload();
      } catch (updateError) {
        console.error("カート更新エラー:", updateError);
      }
    }
  } catch (error) {
    console.error("syncPeladaCampaign実行中のエラー:", error);
  }
}

syncPeladaCampaign();

// START *************************************************** BPLUS CAMPAIGN
// BPlusキャンペーン: 対象商品とプレゼント商品を同数にする
async function syncBPlusCampaign() {
  if (isSyncingBPlus) return; // 処理中なら実行しない
  isSyncingBPlus = true;
  
  try {
    // 対象商品のハンドル
    const baseProductHandle = "wt0010-bp";
    const linkedProductHandle = "tyousei-bpe";
    
    // tyousei-bpeのvariantID（テスト環境用）
    // const linkedVariantId = 46074645250199;
    // 本番環境用のvariantID
    const linkedVariantId = 52131899900222;
    
    // BPlus商品に既存のラッピングがある場合は削除
    const bPlusProductsWithWrapping = cartItems.filter(item => 
      (item.handle === baseProductHandle || item.handle === linkedProductHandle) && 
      item.wrapping && item.wrapping.length > 0
    );
    
    if (bPlusProductsWithWrapping.length > 0) {
      console.log("BPlusキャンペーン: 既存のラッピング商品を削除します");
      
      for (const product of bPlusProductsWithWrapping) {
        for (const wrapping of product.wrapping) {
          console.log("ラッピング商品削除:", wrapping);
          try {
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                line: wrapping.line,
                quantity: 0,
              }),
            });
            
            if (response.ok) {
              console.log("BPlusキャンペーン: ラッピング商品の削除が完了しました");
            }
          } catch (error) {
            console.error("ラッピング商品削除エラー:", error);
          }
        }
      }
      
      // ラッピング削除後にページをリロードして処理を続行
      window.location.reload();
      return;
    }
    
    // カート内の基準商品を取得
    const BASE_PRODUCT = cartItems.filter((item) => 
      item.handle === baseProductHandle
    );
    const BASE_PRODUCT_COUNT = BASE_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
    
    // カート内の連動商品を取得
    const LINKED_PRODUCT = cartItems.filter(
      (item) => item.handle === linkedProductHandle
    );
    const LINKED_PRODUCT_COUNT = LINKED_PRODUCT.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
    
    console.log(
      "BPlusキャンペーン - 基準商品数量:",
      BASE_PRODUCT_COUNT,
      "連動商品数量:",
      LINKED_PRODUCT_COUNT,
      "数量差異があるか:",
      BASE_PRODUCT_COUNT !== LINKED_PRODUCT_COUNT
    );
    
    // 数量が異なる場合は同期
    if (BASE_PRODUCT_COUNT !== LINKED_PRODUCT_COUNT) {
      if (BASE_PRODUCT_COUNT === 0 && LINKED_PRODUCT_COUNT > 0) {
        // 基準商品が0の場合、連動商品も削除
        const linkedLineIndex = cartItems.findIndex(
          (item) => item.id === linkedVariantId
        );
        if (linkedLineIndex !== -1) {
          console.log("BPlusキャンペーン: 連動商品を削除します");
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              line: linkedLineIndex + 1,
              quantity: 0,
            }),
          });

          if (response.ok) {
            console.log("BPlusキャンペーン: 連動商品の削除が完了しました");
            window.location.reload();
          }
        }
      } else if (LINKED_PRODUCT_COUNT === 0 && BASE_PRODUCT_COUNT > 0) {
        // 連動商品を追加
        console.log("BPlusキャンペーン: 連動商品を追加します", BASE_PRODUCT_COUNT, "個");
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: linkedVariantId,
            quantity: BASE_PRODUCT_COUNT,
          }),
        });

        if (response.ok) {
          console.log("BPlusキャンペーン: 連動商品の追加が完了しました");
          window.location.reload();
        }
      } else if (LINKED_PRODUCT_COUNT > 0) {
        // 数量を調整
        const linkedLineIndex = cartItems.findIndex(
          (item) => item.id === linkedVariantId
        );
        if (linkedLineIndex !== -1) {
          console.log("BPlusキャンペーン: 連動商品の数量を調整します", BASE_PRODUCT_COUNT, "個に");
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              line: linkedLineIndex + 1,
              quantity: BASE_PRODUCT_COUNT,
            }),
          });

          if (response.ok) {
            console.log("BPlusキャンペーン: 連動商品の数量調整が完了しました");
            window.location.reload();
          }
        }
      }
    }
  } catch (error) {
    console.error("syncBPlusCampaign実行中のエラー:", error);
  } finally {
    isSyncingBPlus = false;
  }
}

syncBPlusCampaign();
// END *************************************************** BPLUS CAMPAIGN

// END *************************************************** CART CUSTOM CAMPAIGN

// START *************************************************** CART GIFT QUANTITY
// GIFT RAPPING 商品が元の商品と同数になっているか確認
const adjustGiftQuantity = () => {
  CART_ITEMS.forEach((item) => {
    // wrappingがある場合、wrappingの数量を元の商品と同数にする
    if (item.wrapping.length) {
      const wrapping = item.wrapping[0];
      const wrappingQuantity = wrapping.quantity;
      const originalQuantity = item.quantity;
      if (wrappingQuantity <= originalQuantity) return;

      // wrappingの数量が元の商品より多い場合、wrappingの数量を元の商品と同数にする
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: wrapping.line,
          quantity: originalQuantity,
        }),
      })
        .then((response) => {
          if (response.ok) {
            console.log("wrappingの数量を元の商品と同数にしました");
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  });
};
adjustGiftQuantity();
// END *************************************************** CART GIFT QUANTITY

// START *************************************************** CROWDFUNDING CART NOTE

// UPDATE CART NOTE
async function updateCartNote(note) {
  const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

// ENSURE CART NOTE SAVED BEFORE CHECKOUT
const ensureCartNoteSaved = async () => {
  const noteArea = document.querySelector('.crowdfund-cart-note textarea');
  if (!noteArea) return; // クラファン商品がない場合は何もしない

  const currentValue = noteArea.value;

  // 未保存チェック
  const hasUnsavedChanges = currentValue !== cartNoteSavedValue;

  if (!hasUnsavedChanges) {
    return; // 保存済み → 何もしない
  }

  // 未保存 → 保存完了を待つ
  disableCheckOutButton();

  try {
    // 新規保存
    await updateCartNote(currentValue);
    cartNoteSavedValue = currentValue;

    console.log('✅ Cart note ensured saved');
    // 成功時: ボタンは有効化しない
  } catch (error) {
    console.error('❌ Cart note save failed:', error);
    // エラー時のみ: ボタンを有効化（再試行のため）
    enableCheckOutButton();
    throw error; // checkoutを中断
  }
};

// CART FORM SUBMIT HANDLER
document.addEventListener('DOMContentLoaded', () => {
  // クラウドファンディング商品のノートエリアを取得（一度だけ）
  const noteArea = document.querySelector('.crowdfund-cart-note textarea');
  
  // CHECKOUT BUTTON CLICK HANDLER (PC & SP)
  const checkoutButtons = [
    document.querySelector('#cart-checkout[type="button"]'),
    document.querySelector('#cart-checkout-sp[type="button"]')
  ].filter(Boolean); // nullを除外

  if (checkoutButtons.length > 0 && noteArea) {
    checkoutButtons.forEach(checkoutButton => {
      const handleCheckoutClick = async (e) => {
        e.preventDefault();

        console.log('🔍 Debug: noteArea value:', noteArea.value);

        try {
          await ensureCartNoteSaved();

          // ボタンのタイプをsubmitに変更してフォームを送信
          checkoutButton.type = 'submit';
          checkoutButton.removeEventListener('click', handleCheckoutClick);
          checkoutButton.click();
        } catch (error) {
          console.error('Error:', error);
        }
      };

      checkoutButton.addEventListener('click', handleCheckoutClick);
    });
  }

  // LOGIN BUTTON CLICK HANDLER
  const loginButtons = [
    document.getElementById('cart-checkout-login'),
    document.getElementById('cart-checkout-login-sp')
  ].filter(Boolean); // nullを除外

  if (loginButtons.length > 0 && noteArea) {
    loginButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        console.log('🔍 Debug: Login button click event fired');
        e.preventDefault();

        try {
          await ensureCartNoteSaved();
          console.log('🔍 Debug: ensureCartNoteSaved completed, navigating to:', button.href);
          window.location.href = button.href;
        } catch (error) {
          console.error('🔍 Debug: Error caught:', error);
        }
      });
    });
  }
});

// END *************************************************** CROWDFUNDING CART NOTE
//26.8.18customチェック　START
const ENABLE_CUSTOM_CHECK = true;//エラー緊急対応、falseはチェックを止める

const checkoutButtons = [
  document.getElementById("cart-checkout"),
  document.getElementById("cart-checkout-sp"),
];

checkoutButtons.forEach((btn) => {
  if (!btn) return;
  if(crowdfundingProduct) return;

  btn.addEventListener("click", async () => {
    if (ENABLE_CUSTOM_CHECK) {
      const checkok = await checkCustomItemsBeforeCheckout();
      if (!checkok) return;
    }
    const form = btn.closest("form");
    if (!form) return;  
    const checkoutInput = document.createElement("input");
    checkoutInput.type = "hidden";
    checkoutInput.name = "checkout";
    checkoutInput.value = "checkout";
    form.appendChild(checkoutInput);
    form.submit();
  });
});

const loginButtons = [
  document.getElementById("cart-checkout-login"),
  document.getElementById("cart-checkout-login-sp"),
];

loginButtons.forEach((btn) => {
  if (!btn) return;
  if(crowdfundingProduct) return;

  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    if (ENABLE_CUSTOM_CHECK) {
      const checkok = await checkCustomItemsBeforeCheckout();
      if (!checkok) return;
    }
    window.location.href = btn.href;
  });
});

async function checkCustomItemsBeforeCheckout() {
  try {
    const response = await fetch("/cart.js");

    if (!response.ok) {
      console.error("cart取得失敗");
      return false;
    }

    const cart = await response.json();
    const customItems = cart.items.filter(
      (item) => item.properties?._custom === "custom"
    );
    console.log("名入れ商品:", customItems);
    // 名入れ商品がなければそのままcheckout
    if (customItems.length === 0) {
      return true;
    }

    // 名入れ商品がある場合、正常かチェック
    const invalidItems = customItems.filter(
      (item) => !isCustomItemValid(item, cart)
    );

    if (invalidItems.length === 0) {
      return true;
    }

    console.warn("名入れ情報異常商品:", invalidItems);
    await removeBrokenItems(invalidItems);

showCustomErrorModal(invalidItems[0]);

    return false;
  } catch (error) {
    console.error("名入れ商品チェックエラー:", error);
    return false;
  }
}

function isCustomItemValid(item, cart) {
  const sku = item.sku;
  console.log(
  "CustomTarget対象:",
  cart.items
    .filter((cartItem) => cartItem.properties?._CustomTarget === sku)
    .map((cartItem) => ({
      title: cartItem.product_title,
      sku: cartItem.sku,
      quantity: cartItem.quantity,
      custom: cartItem.properties?._custom,
      CustomTarget: cartItem.properties?._CustomTarget,
    }))
);
  // 同じSKUの名入れ本体数量を合計
  const customProductQuantity = cart.items
    .filter(
      (cartItem) =>
        cartItem.properties?._custom === "custom" &&
        cartItem.sku === sku
    )
    .reduce(
      (total, cartItem) => total + cartItem.quantity,
      0
    );

  // 対応するCPB商品の数量を合計
  const customQuantity = cart.items
    .filter(
      (cpbItem) =>
        cpbItem.properties?._CustomTarget === sku
    )
    .reduce(
      (total, cpbItem) => total + cpbItem.quantity,
      0
    );

  console.log("sku:", sku);
  console.log("customProductQuantity:", customProductQuantity);
  console.log("customQuantity:", customQuantity);

  return customQuantity === customProductQuantity;
}

async function removeBrokenItems(items) {
  const cartResponse = await fetch("/cart.js");

  if (!cartResponse.ok) {
    return false;
  }

  const cart = await cartResponse.json();

  const invalidSkus = [...new Set(items.map((item) => item.sku))];

  // CPB商品を削除
  const cpbItems = cart.items.filter(
    (cpbItem) =>
      invalidSkus.includes(cpbItem.properties?._CustomTarget)
  );

  for (const cpbItem of cpbItems) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: cpbItem.key,
        quantity: 0,
      }),
    });

    if (!response.ok) return false;
  }

  // エラーになった本体商品を削除
  for (const item of items) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: item.key,
        quantity: 0,
      }),
    });

    if (!response.ok) return false;
  }

  return true;
}
function showCustomErrorModal(item) {
  const overlay = document.createElement("div");
  overlay.innerHTML = `
<div class="custom-error-overlay">
  <div class="custom-error-modal">
    <p class="custom-error-ttl">
  【システムエラー】
     </p>
    <p class="custom-error-message">
    
      申し訳ございませんが一部の注文情報が正しく登録されませんでした。<br>
下記エラー商品について再度商品ページから名入れ注文をやり直してください。<br>
※この画面を閉じると、エラー商品はカートから削除されます。<br>
※ご購入前にカートの内容がご希望の内容になっているか必ずご確認ください。<br>
▼エラー商品
    </p>

<p class="custom-error-action">
  <a href="${item.url}" class="custom-error-link">
    ${item.product_title}
  </a>
</p>


<p class="custom-error-close-wrap">
  <button id="custom-error-close" class="custom-error-close-btn">
    閉じる
  </button>
</p>

  </div>
</div>
`;

  document.body.appendChild(overlay);

document
  .getElementById("custom-error-close")
  .addEventListener("click", () => {
    location.reload();
  });
}
//26.8.18customチェック  END
/****************************************************** 2026.8.25 discount deck try*/
function modalLayout(){
  document
  .querySelector('.dd-close-button-floating path')
  ?.setAttribute('stroke-width', '1');
  if (window.matchMedia('(max-width: 767px)').matches) {
  const description = document.querySelector('.dd-popup-description');

  if (description) {
    description.innerHTML = description.textContent.replace(
      'クーポンは以下',
      'クーポンは<br>以下'
    );
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
  document.querySelectorAll(".dd-copy-button").forEach((btn) => {
    if (btn.textContent.trim() === "クーポンコードをコピーする") {
      btn.textContent = "クーポンコードをコピー";
    }
  });

}
}
}